/* Shared O&M design atoms — deep navy surfaces, gold accents, Inter. */
export const NAVY = "#0A1628";
export const CARD = "#112240";
export const GOLD = "#C9A84C";
export const MUTED = "#8892B0";
export const RED = "#EF4444";
export const AMBER = "#F59E0B";
export const GREEN = "#00C896";
export const FIELD = { background: "#0D1B2A", borderColor: "rgba(201,168,76,0.25)", color: "#FFFFFF" };

export const OmCard = ({ children, className = "", testid }) => (
  <div className={`border p-4 ${className}`} style={{ background: CARD, borderColor: "rgba(201,168,76,0.16)", borderRadius: 8 }} data-testid={testid}>
    {children}
  </div>
);

export const OmHead = ({ title, subtitle, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
    <div>
      <h2 className="text-white font-semibold" style={{ fontSize: 24 }}>{title}</h2>
      {subtitle ? <p className="text-[13px] mt-0.5" style={{ color: MUTED }}>{subtitle}</p> : null}
    </div>
    <div className="flex flex-wrap items-center gap-2">{children}</div>
  </div>
);

export const OmKpi = ({ label, value, tone, testid }) => (
  <OmCard testid={testid}>
    <div className="text-[10.5px] uppercase tracking-[0.14em]" style={{ color: MUTED }}>{label}</div>
    <div className="font-semibold mt-1 tabular-nums" style={{ fontSize: 26, color: tone || GOLD }}>{value}</div>
  </OmCard>
);

const TONES = { good: GREEN, warn: AMBER, bad: RED, muted: MUTED, gold: GOLD };

export const Pill = ({ tone = "muted", children, testid }) => {
  const c = TONES[tone] || MUTED;
  return (
    <span
      className="inline-block px-2 py-0.5 text-[10.5px] font-medium whitespace-nowrap"
      style={{ color: c, background: `${c}1F`, border: `1px solid ${c}55`, borderRadius: 999 }}
      data-testid={testid}
    >
      {children}
    </span>
  );
};

export const statusTone = (s) =>
  ({ Operational: "good", Completed: "good", Verified: "good", Resolved: "good", Closed: "good", Normal: "good",
     "Under Maintenance": "warn", "In Progress": "warn", Assigned: "warn", Warning: "warn", Scheduled: "gold",
     Faulty: "bad", Critical: "bad", Open: "bad", High: "bad", Decommissioned: "muted" }[s] || "muted");

export const HealthRing = ({ value, size = 54 }) => {
  const color = value >= 80 ? GREEN : value >= 50 ? AMBER : RED;
  const r = (size - 6) / 2;
  const circ = 2 * Math.PI * r;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} data-testid="health-ring" data-health={value}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="5" />
      <circle
        cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth="5" strokeLinecap="round"
        strokeDasharray={`${(circ * value) / 100} ${circ}`} transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: "stroke-dasharray 0.5s ease" }}
      />
      <text x="50%" y="54%" textAnchor="middle" dominantBaseline="middle" fill={color} fontSize={size / 3.6} fontWeight="600">
        {value}
      </text>
    </svg>
  );
};

export const OmTable = ({ head, children, testid }) => (
  <div className="overflow-x-auto" data-testid={testid}>
    <table className="w-full text-[12.5px]">
      <thead>
        <tr style={{ borderBottom: "1px solid rgba(201,168,76,0.22)" }}>
          {head.map((h) => (
            <th key={h} className="text-left font-medium px-3 py-2 whitespace-nowrap text-[10.5px] uppercase tracking-[0.1em]" style={{ color: GOLD }}>
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);

export const Row = ({ i, children, testid }) => (
  <tr style={{ background: i % 2 ? CARD : "transparent", color: "#fff" }} data-testid={testid}>
    {children}
  </tr>
);

export const Td = ({ children, className = "" }) => <td className={`px-3 py-2 align-middle ${className}`}>{children}</td>;

export const chartTheme = {
  grid: "rgba(255,255,255,0.08)",
  axis: MUTED,
  tooltip: { background: CARD, border: `1px solid ${GOLD}55`, borderRadius: 8, fontSize: 12, color: "#fff" },
};
